module.exports = __webpack_public_path__ + "img/laddercontroladvantage2.adede3a4.png";